// DonutChart.js
import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

// Custom plugin to support individual arc widths
const customArcWidthPlugin = {
  id: 'customArcWidthPlugin',
  beforeDraw(chart) {
    const { config } = chart;
    const meta = chart.getDatasetMeta(0);
    const arcWidths = config.options.customArcWidths || [];

    meta.data.forEach((arc, index) => {
      const thickness = arcWidths[index] || 30;
      arc.outerRadius = arc.innerRadius + thickness;
    });
  },
};

ChartJS.register(customArcWidthPlugin);

const Blanklink = () => {
  const data = {
    labels: ["Content 1", "Content 2", "Content 3"],
    datasets: [
      {
        data: [50, 20, 30],
        backgroundColor: ["#728CC7", "#e5a4c4", "#6a4caf"],
        borderWidth: 0,
        borderRadius: "5px",
      },
    ],
  };

  const options = {
    cutout: "40%",
    customArcWidths: [80, 65, 55],
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          padding: 20,
          font: {
            size: 14,
            weight: "500"
          },
          color: "#333",
        },
      },
      tooltip: {
        enabled: true, // ❌ Turn off tooltip if you also don't want hover values
      },
      datalabels: {
        display: false, // ⛔ Explicitly disable data labels if plugin is registered
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="black-chart-container">
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default Blanklink;
